<template>
    <div class="zq-popup zq-popup--visible">
        <div class="zq-popup__container">
            <div class="zq-popup__title">
                <translate>Request to add person created</translate>
                <div @click="closePopup()" class="zq-popup__close-button"></div>
            </div>
            <div class="zq-popup__content custom-scroller">
                <p v-translate>We've sent the user an email to confirm your request.</p>
                <p v-translate>The person will appear on this page as soon as he/she approves it.</p>
            </div>
            <div class="zq-popup__bottom">
                <button @click="closePopup()" class="button button--gray" v-translate>Close</button>
            </div>
        </div>
    </div>
</template>
<script>
    import {mapActions} from 'vuex';

    export default {
        name: 'PersonRequestAdded',

        methods: {
            ...mapActions([
                'closePopup'
            ])
        }
    }
</script>